import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import { ShowToast } from '../../common/Toastr';
import { getDecimalFromTime } from '../../common/timesheetFunction';
import { addCalendarTimeEntry, updateEventFalg } from './CalendarSlice';
import { dateFormatByAccountCulture, determineCommaSeprater, formatNumberCustomoriginalapiv2, getFormattedCustomField, getValueFromResource, validateCultureNumber } from '../../common/timeLiveFunction';
import { SelectionOption } from './TimeEntrySelection';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import CustomDropdownModal from './CustomDropdownModal';
import DatePicker from "react-datepicker";
import { CustomCalendarContainer } from '../../common/CustomCalendarContainer';
import { CurrentCultureDateFormat } from '../../common/UiUtilities';
import { t } from 'i18next';


interface AddEventModalProps {
    oncloseModal: () => void;
    // selectedEvent?: any;
    presetStartTime: string;
    clickedDate?: Date;
    presetEndTime: string;
}

const AddTimeEntry: React.FC<AddEventModalProps> = ({
    oncloseModal,
    // selectedEvent,
    presetStartTime,
    clickedDate = new Date(),
    presetEndTime,
}) => {
    const dispatch = useAppDispatch();
    const { isLoading } = useAppSelector((state) => state.expensetype);
    const { calendarStartDay, maxMenuHeight, showClientInTimesheet, showCostCenterInTimeSheet, showWorkTypeInTimeSheet, customFieldInsertionFormat, CurrentCultureDateFormat, cultureInfoName, decimalPlaces } = useAppSelector((state) => state.globalState);
    const { Submitted, TimeEntryViewType, AccountEmployeeTimeEntryPeriodId, TimeEntryEndDate, TimeEntryStartDate, timeEntryData, isLocked, customFields, isShowCustomFields, workingDayType, DummyRangePeriod } = useAppSelector((state) => state.calendar);
    const [eventDate, setEventDate] = useState<Date>(clickedDate);
    const [eventEndDate, setEventEndDate] = useState<Date>(clickedDate);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [totalTime, setTotalTime] = useState('');
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [selectedClient, setSelectedClient] = useState<SelectionOption>({ label: '', value: null });
    const [selectedProject, setSelectedProject] = useState({ label: '', value: null, clientId: null });
    const [selectedTask, setSelectedTask] = useState<SelectionOption>({ label: '', value: null });
    const [selectedCost, setSelectedCost] = useState<SelectionOption>({ label: '', value: null });
    const [selectedWorktype, setSelectedWorktype] = useState<SelectionOption>({ label: '', value: null });
    const [description, setDescription] = useState('');
    const [timesheetError, setTimesheetError] = useState([]);
    const [showTimezonePopover, setShowTimezonePopover] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const iconRef = useRef<HTMLDivElement>(null);
    const [popoverPosition, setPopoverPosition] = useState({ top: 0, left: 0 });
    const endDateInputRef = useRef<HTMLInputElement>(null);
    const [cfValues, setCfValues] = useState<any>({
        CustomField1: "",
        CustomField2: "",
        CustomField3: "",
        CustomField4: "",
        CustomField5: "",
        CustomField6: "",
        CustomField7: "",
        CustomField8: "",
        CustomField9: ""
    });
    // const sourceId = selectedEvent?.extendedProps?.type || '';
    // const updateInternalEvent = selectedEvent?.extendedProps?.type === 'internal' && selectedProject?.value == null && selectedClient?.value == null;
    const calculateTotalTime = (start: string, end: string) => {
        if (!start || !end) return '';
        const startDate = new Date(`1970-01-01T${start}`);
        const endDate = new Date(`1970-01-01T${end}`);
        const diffMs = endDate.getTime() - startDate.getTime();
        if (isNaN(diffMs) || diffMs < 0) return '';
        const hrs = String(Math.floor(diffMs / 3600000)).padStart(2, '0');
        const mins = String(Math.floor((diffMs % 3600000) / 60000)).padStart(2, '0');
        return `${hrs}:${mins}:00`;
    };

    const setDefaultTimes = (baseDate: Date) => {
        const start = moment(baseDate).format("HH:mm");
        const end = moment(baseDate).add(1, 'hour').format("HH:mm");
        setStartTime(start);
        setEndTime(end);
        setTotalTime(calculateTotalTime(start, end));
    };

    const getDisplayText = () => {
        const task = selectedTask?.label;

        const others = [
            selectedClient?.label,
            selectedProject?.label
                ? selectedProject.label
                : (
                    <span style={{ color: '#172b4d' }}>
                        {`${getValueFromResource('Select', dispatch, t)} ` + [
                            showClientInTimesheet && getValueFromResource('Client', dispatch, t),
                            getValueFromResource('Project', dispatch, t),
                            getValueFromResource('Task', dispatch, t),
                            showCostCenterInTimeSheet && getValueFromResource('Cost Center', dispatch, t),
                            showWorkTypeInTimeSheet && getValueFromResource('Work Type', dispatch, t),
                        ].filter(Boolean).join(' - ')}
                    </span>
                    // <span style={{ color: '#172b4d' }}>
                    //     {`${getValueFromResource('Select Project', dispatch, t)} - ${getValueFromResource('Task', dispatch, t)}`}
                    // </span>
                ),
            selectedCost?.label,
            selectedWorktype?.label,
        ].filter(Boolean);

        return (
            <div>
                <div>
                    {!dropdownVisible && task && <div><strong>{task}</strong></div>}
                    {!dropdownVisible && others.length > 0 ? (
                        <div style={{ fontSize: '12px', color: '#555' }}>
                            {others.map((item, i) => (
                                <span key={i} className="rowItemColor">
                                    {i > 0 && ' • '}
                                    {item}
                                </span>
                            ))}
                        </div>
                    ) : (
                        <span style={{ color: '#172b4d' }}>
                            {`${getValueFromResource('Select', dispatch, t)} ` + [
                                showClientInTimesheet && getValueFromResource('Client', dispatch, t),
                                getValueFromResource('Project', dispatch, t),
                                getValueFromResource('Task', dispatch, t),
                                showCostCenterInTimeSheet && getValueFromResource('Cost Center', dispatch, t),
                                showWorkTypeInTimeSheet && getValueFromResource('Work Type', dispatch, t),
                            ].filter(Boolean).join(' - ')}
                        </span>
                        // <span style={{ color: '#172b4d' }}>
                        //     {`${getValueFromResource('Select Project', dispatch, t)} - ${getValueFromResource('Task', dispatch, t)}`}
                        // </span>
                    )}
                </div>

            </div>
        );
    };

    const handleSubmit = async () => {
        // if (startTime === endTime && moment(eventDate).isSame(moment(eventEndDate), 'day')) {
        //     ShowToast('error', 'Start and end Date/Time cannot be the same.', "error", "toast-top-right");
        //     return;
        // }
        const sameDay = moment(eventDate).isSame(moment(eventEndDate), 'day');
        const start = moment(`${moment(eventDate).format("YYYY-MM-DD")} ${startTime}`, "YYYY-MM-DD HH:mm");
        const end = moment(`${moment(eventDate).format("YYYY-MM-DD")} ${endTime}`, "YYYY-MM-DD HH:mm");

        if (sameDay && startTime === endTime) {
            ShowToast('error', 'Start and end time cannot be the same on the same day.', "error", "toast-top-right");
            return;
        }

        if (sameDay && end.isBefore(start)) {
            ShowToast('error', 'End time cannot be before start time on the same day.', "error", "toast-top-right");
            return;
        }
        const formattedCfValues: any = {};
        Object.keys(cfValues).forEach(key => {
            formattedCfValues[key] = getFormattedCustomField(customFields, key, cfValues[key]);
        });
        let payload: any[] = [];

        const { AccountEmployeeId, AccountWorkTypeId, AccountEmployeeTimeEntryPeriodId, AccountId, Submitted, AccountEmployeeTimeEntryId } = DummyRangePeriod[0];
        payload = [{
            IsTimeOff: false,
            IsSubmitted: Submitted,
            TimesheetPeriodType: TimeEntryViewType,
            AccountEmployeeTimeEntryPeriodId: AccountEmployeeTimeEntryPeriodId,
            AccountEmployeeId,
            AccountEmployeeTimeEntryId: AccountEmployeeTimeEntryId,
            AccountClientId: !showClientInTimesheet ? selectedProject?.clientId : selectedClient.value ?? 0,
            AccountProjectId: selectedProject?.value ?? 0,
            AccountProjectTaskId: selectedTask?.value ?? 0,
            AccountCostCenterId: selectedCost?.value ?? 0,
            AccountWorkTypeId: !showWorkTypeInTimeSheet ? AccountWorkTypeId : selectedWorktype?.value ?? 0,
            AccountTimeOffTypeId: null,
            Hours: getDecimalFromTime(totalTime, false),
            Percentage: null,
            PeriodStartDate: moment(TimeEntryStartDate).format("YYYY-MM-DD"),
            PeriodEndDate: moment(TimeEntryEndDate).format("YYYY-MM-DD"),
            TimeEntryDate: moment(eventDate).format("YYYY-MM-DD"),
            StartTime: moment(`${moment(eventDate).format("YYYY-MM-DD")} ${startTime}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DDTHH:mm:ss"),
            EndTime: moment(`${moment(eventDate).format("YYYY-MM-DD")} ${endTime}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DDTHH:mm:ss"),
            Description: description || '',
             ...formattedCfValues
            // ...cfValues
        }];
        const response = await dispatch(addCalendarTimeEntry(payload));
        const result = response.payload;
        if (String(result?.StatusCode) !== '201') {
            setTimesheetError(result?.Data || []);
            return;
        } else {
            dispatch(updateEventFalg(true));
            oncloseModal();
        }
        dispatch(updateEventFalg(true));
        oncloseModal();
    };

    const onChangeHandler = (e: any) => {
        setCfValues({ ...cfValues, [e.target.name]: e.target.value });
    }

    const onChangeHandlerForDatePicker = (e: any, name: any) => {
        const date = e ? moment(e).format(customFieldInsertionFormat) : moment().format(customFieldInsertionFormat);
        setCfValues({ ...cfValues, [name]: date });
    }

    const calculatePopoverPosition = () => {
        if (iconRef.current) {
            const rect = iconRef.current.getBoundingClientRect();
            setPopoverPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX
            });
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;

            if (dropdownVisible &&
                dropdownRef.current &&
                !dropdownRef.current.contains(target) &&
                !target.closest?.('.dropdown-trigger')) {
                setDropdownVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownVisible]);

    useEffect(() => {
        if (showTimezonePopover) {
            calculatePopoverPosition();
            window.addEventListener('resize', calculatePopoverPosition);
            window.addEventListener('scroll', calculatePopoverPosition);

            return () => {
                window.removeEventListener('resize', calculatePopoverPosition);
                window.removeEventListener('scroll', calculatePopoverPosition);
            };
        }
    }, [showTimezonePopover, iconRef]);

    useEffect(() => {

        if (presetStartTime && presetEndTime) {
            setStartTime(presetStartTime);
            setEndTime(presetEndTime);
            setTotalTime(calculateTotalTime(presetStartTime, presetEndTime));
        } else {
            setDefaultTimes(new Date());
        }

    }, [presetStartTime, presetEndTime]);

    useEffect(() => {
        if (customFields?.length > 0) {
            let NewCfValue = { ...cfValues };
            customFields?.filter((x: any) => !x.IsDisabled)
                .map((x: any) => {
                    if (cfValues[x.DatabaseFieldName] == "" && x.DefaultValue != "" && x.MasterCustomDataTypeName != "Date") {
                        NewCfValue[x.DatabaseFieldName] = x.DefaultValue;
                    }
                    if (cfValues[x.DatabaseFieldName] == "" && x.MasterCustomDataTypeName == "Date") {
                        NewCfValue[x.DatabaseFieldName] = moment(new Date()).format(customFieldInsertionFormat);
                    }
                });
            setCfValues(NewCfValue);
        }
    }, [customFields])

    return (
        <>
            <div className="modal-body" style={{ overflowY: 'auto', flexGrow: 1 }} onScroll={() => {
                setDropdownVisible(false);
                setShowTimezonePopover(false)
            }}>
                {timesheetError.length > 0 && timesheetError.map((item: any) => (
                    <div className="alert alert-danger py-2 px-3 mb-3">
                        {item?.ErrorMessage}
                    </div>
                ))}
                <div
                    className="dropdown-trigger"
                    style={{
                        display: 'flex',
                        cursor: isLocked ? 'not-allowed' : 'pointer',
                        border: "1px solid #eee",
                        padding: "10px",
                        borderRadius: "5px",
                        opacity: isLocked ? 0.6 : 1,
                        pointerEvents: isLocked ? 'none' : 'auto'
                    }}
                    onClick={() => {
                        setDropdownVisible(prev => !prev);
                    }}
                >
                    <i className="ki-outline ki-add-item fs-4" style={{ color: '#000' }}></i>
                    <span style={{ paddingLeft: 4 }}>{getDisplayText()}</span>
                </div>
                {dropdownVisible && (
                    <div ref={dropdownRef}>
                        <CustomDropdownModal
                            isCalendar
                            setDropdownVisible={setDropdownVisible}
                            preSelectedData={{
                                client: selectedClient,
                                project: selectedProject,
                                task: selectedTask,
                                cost: selectedCost,
                                worktype: selectedWorktype
                            }}
                            onSelectionComplete={({ client, project, task, cost, worktype }: any) => {
                                if (client) setSelectedClient(client);
                                if (project) setSelectedProject(project);
                                if (task) setSelectedTask(task);
                                if (cost) setSelectedCost(cost);
                                if (worktype) setSelectedWorktype(worktype);
                            }}
                        />
                    </div>
                )}
                <div className="my-4">
                    <label className="form-label fs-7 fw-normal mb-2">
                        {getValueFromResource('Date & Time', dispatch, t)} {/*<i className="bi bi-info-circle-fill fs-5 iconColor allign ms-1 cursor-pointer" data-tooltip-id="tooltip-TimeEntry" data-tooltip-content={getValueFromResource('Easily view and manage how your daily hours are divided across the day.', dispatch, t)}></i>*/}
                    </label>

                    <div className="d-flex align-items-center gap-2 mb-4">
                        <div className="col-md-3 wrapper">
                            <DatePicker
                                selected={eventDate}
                                onChange={(date) => setEventDate(date || new Date())}
                                calendarStartDay={calendarStartDay}
                                className="form-control form-control-dark btn-icon-dark btn-text-dark"
                                dateFormat={CurrentCultureDateFormat.toString()}
                                popperContainer={({ children }: any) => (
                                    <CustomCalendarContainer inputRef={endDateInputRef}>
                                        {children}
                                    </CustomCalendarContainer>
                                )}
                                readOnly={true}
                            // readOnly={isLocked}
                            >
                            </DatePicker>
                            <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                        </div>
                        <div className="col-md-3 " >
                            <input
                                type="time"
                                name="startTime"
                                value={startTime}
                                onChange={(e) => {
                                    const newStartTime = e.target.value;
                                    const newTotalTime = calculateTotalTime(newStartTime, endTime);
                                    setStartTime(newStartTime);
                                    setTotalTime(newTotalTime);
                                }}
                                className="form-control fs-7 fw-normal range-time"
                                style={{ height: '40.94px' }}
                                readOnly={isLocked}
                            //readOnly={(((sourceId === 'google' || sourceId === 'outlook') || sourceId === 'timeEntry' || sourceId === 'internal') && isLocked)}
                            />
                        </div>

                        <div className="col-md-3">
                            <input
                                type="time"
                                name="endTime"
                                value={endTime}
                                onChange={(e) => {
                                    const newEndTime = e.target.value;
                                    const newTotalTime = calculateTotalTime(startTime, newEndTime);
                                    setEndTime(newEndTime);
                                    setTotalTime(newTotalTime);
                                }}
                                className="form-control fs-7 fw-normal range-time"
                                style={{ height: '40.94px' }}
                                readOnly={isLocked}
                            //readOnly={(((sourceId === 'google' || sourceId === 'outlook') || sourceId === 'timeEntry' || sourceId === 'internal') && isLocked)}
                            />
                        </div>
                        <div className="col-md-3 " style={{ maxWidth: "129px", position: 'relative' }}>
                            <input
                                type="text"
                                className="form-control text-center fw-semibold"
                                name="totalTime"
                                value={totalTime}
                                readOnly
                                style={{ height: '40.95px' }}
                            />
                        </div>
                    </div>
                </div>
                <div className="my-4">
                    <label className="form-label fs-7 fw-normal mb-2">{getValueFromResource('Description', dispatch, t)}</label>
                    <textarea
                        rows={4}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        className="form-control"
                        readOnly={isLocked}
                    // readOnly={(((sourceId === 'google' || sourceId === 'outlook') || sourceId === 'timeEntry' || sourceId === 'internal') && isLocked)}
                    />
                </div>

                <div>
                    {isShowCustomFields && customFields?.length > 0 && customFields?.filter((x: any) => !x.IsDisabled).map((x: any, index: any) => {
                        return (
                            <div key={index} className={"custom-field-item my-4"}>
                                <label className={"d-block custom-field-label form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                {x.MasterCustomDataTypeName == "Drop-Down" &&
                                    <select
                                        name={x.DatabaseFieldName}
                                        className={"form-control form-control-sm input-sm custom-field cf-select"}
                                        onChange={onChangeHandler}
                                        required={x.IsRequired ? x.IsRequired : ""}
                                        disabled={isLocked ? true : false}
                                        value={cfValues[x.DatabaseFieldName] || ""}
                                    >
                                        <option value="None">None</option>
                                        {x.DropDownOptions != null &&
                                            x.DropDownOptions.split("+").map((value: any, index: any) =>
                                                <option key={index} value={value} >{value}</option>)
                                        }
                                    </select>}
                                {x.MasterCustomDataTypeName == "Date" &&
                                    <DatePicker
                                        name={x.DatabaseFieldName}
                                        onChange={(date) => onChangeHandlerForDatePicker(date, x.DatabaseFieldName)}
                                        disabled={isLocked ? true : false}
                                        calendarStartDay={calendarStartDay}
                                        selected={(cfValues[x.DatabaseFieldName] ? dateFormatByAccountCulture(cfValues[x.DatabaseFieldName], cultureInfoName.toString()) : new Date())}
                                        className={"form-control form-control-sm input-sm custom-field custom-field " + (isLocked ? 'disabled' : '')}
                                        dateFormat={CurrentCultureDateFormat.toString()}
                                        popperContainer={({ children }: any) => (
                                            <CustomCalendarContainer inputRef={endDateInputRef}>
                                                {children}
                                            </CustomCalendarContainer>
                                        )}
                                    />}
                                {(x.MasterCustomDataTypeName == "Text") &&
                                    <input
                                        name={x.DatabaseFieldName}
                                        defaultValue={cfValues[x.DatabaseFieldName]}
                                        value={cfValues[x.DatabaseFieldName] || ""}
                                        onChange={onChangeHandler}
                                        className={"form-control form-control-sm input-sm custom-field custom-field"}
                                        maxLength={x.MaximumLength ? x.MaximumLength : ""}
                                        max={x.MaximumValue ? x.MaximumValue : ""}
                                        min={x.MinimumValue ? x.MinimumValue : ""}
                                        required={x.IsRequired ? x.IsRequired : ""}
                                        type="text"
                                        disabled={isLocked ? true : false}
                                    />}
                                {(x.MasterCustomDataTypeName == "Number") &&
                                    <input
                                        name={x.DatabaseFieldName}
                                        defaultValue={cfValues[x.DatabaseFieldName]}
                                        value={cfValues[x.DatabaseFieldName] || ""}
                                        // onChange={onChangeHandler}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const isCommaSeparator = determineCommaSeprater(cultureInfoName.toString());
                                            if (isCommaSeparator && value.includes('.')) {
                                                return;
                                            }
                                            if (!isCommaSeparator && value.includes(',')) {
                                                return;
                                            }
                                            if (value === "" || validateCultureNumber(value, cultureInfoName.toString(), decimalPlaces)) {
                                                setCfValues({ ...cfValues, [x.DatabaseFieldName]: value });
                                            }
                                        }}
                                        onBlur={(e) => {
                                            const value = e.target.value;

                                            if (value === '') return;
                                            const normalizedValue = value.toString().replace(',', '.');
                                            const numericValue = parseFloat(normalizedValue);

                                            if (isNaN(numericValue)) return;
                                            const fixedValue = Number(numericValue.toFixed(decimalPlaces));
                                            const formattedValue = formatNumberCustomoriginalapiv2(
                                                cultureInfoName.toString(),
                                                fixedValue,
                                                decimalPlaces
                                            );
                                            setCfValues({ ...cfValues, [x.DatabaseFieldName]: formattedValue });
                                        }}
                                        className={"form-control form-control-sm input-sm custom-field custom-field"}
                                        maxLength={x.MaximumLength ? x.MaximumLength : ""}
                                        max={x.MaximumValue ? x.MaximumValue : ""}
                                        min={x.MinimumValue ? x.MinimumValue : ""}
                                        required={x.IsRequired ? x.IsRequired : ""}
                                        type="text"
                                        disabled={isLocked ? true : false}
                                    />}
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="modal-footer d-flex justify-content-between align-items-center">
                <div>
                    {/* {!showFields && <strong className='fs-4' style={{ paddingLeft: '5px' }}>{totalTime}</strong>} */}
                </div>
                <div className='d-flex gap-2'>
                    <button className="btn btn-secondary btn-sm" onClick={oncloseModal}>
                        {getValueFromResource('Close', dispatch, t)}
                    </button>
                    <button className="btn btn-primary btn-sm" onClick={handleSubmit} disabled={isLocked}>
                        {getValueFromResource('Save', dispatch, t)}
                    </button>
                </div>
            </div>
        </>
    )
}

export default AddTimeEntry